import { $qs, $qsa } from '@js/utils/querySelector';
import Swiper from 'swiper';
import { Navigation, Autoplay, FreeMode, Controller, Scrollbar } from 'swiper/modules';



function slider() {
    const sliderElement = $qs('[data-target="images-quotes-slider"]');

    const imagesQuotesSwiper = new Swiper(sliderElement, {
        modules: [Navigation, Controller, FreeMode, Autoplay, Scrollbar],
        slidesPerView: 1,
        spaceBetween: 50,
        speed: 600,
        loop: true,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}

function imagesQuotesSlider() {
    const blocks = $qsa('[data-block="images-quotes-slider"]');

    if (!blocks) return;
    
    blocks.forEach(block => {
        slider(block);
    });
}

export default imagesQuotesSlider;